import { useEffect } from 'react';
import { WPSCustomEvent } from './types';
import {
  disableCaptchaForAutomation,
  WPS_PAYMENT_COMPONENT_URL,
} from '@src/global/App/constants/constants';

const WPS_PAYMENT_EVENT_NAME = 'wpsPaymentEvent';

export interface WpsPaymentFormProps {
  id?: string;
  amount: number;
  appId: string;
  currency: string;
  email: string;
  intentType: string;
  paymentReference: string;
  paymentToken: string;
  region: string;
  timestamp: number;
  disableCaptcha?: boolean;
  buttonId?: string;
  captchaRetryAttempt?: number;
  locale?: string;
  onSuccess?: (paymentData: WPSCustomEvent['detail']['success']) => void;
  onError?: (error: WPSCustomEvent['detail']['error']) => void;
}

export const WpsPaymentForm = (props: WpsPaymentFormProps) => {
  const id = props.id || 'wps-payment-options';

  useEffect(() => {
    const script = document.createElement('script');
    script.src = WPS_PAYMENT_COMPONENT_URL;
    script.async = true;
    const paymentOptionsElement = document.getElementById(id);

    document.body.appendChild(script);

    const wpsPaymentEventHandler = (event: WPSCustomEvent) => {
      if (!event.detail.success) {
        props.onError(event.detail.error);
        return;
      }

      props.onSuccess(event.detail.success);
    };

    paymentOptionsElement.addEventListener(
      WPS_PAYMENT_EVENT_NAME,
      wpsPaymentEventHandler
    );

    return () => {
      paymentOptionsElement.removeEventListener(
        WPS_PAYMENT_EVENT_NAME,
        wpsPaymentEventHandler
      );
      document.body.removeChild(script);
    };
  }, []);

  const disableProps = props.disableCaptcha ? { disabled: true } : {};

  return (
    <payment-options
      id={id}
      appId={props.appId}
      currency={props.currency}
      email={props.email}
      amount={props.amount}
      intentType={props.intentType}
      region={props.region}
      timestamp={props.timestamp}
      paymentToken={props.paymentToken}
      paymentReference={props.paymentReference}
      buttonId={props.buttonId}
      captchaRetryAttempt={props.captchaRetryAttempt}
      locale={props.locale}
      {...(disableCaptchaForAutomation
        ? {
            isCaptchaTestMode: true,
            captchaSiteKey: '1x00000000000000000000AA',
            captchaTestDescription: 'always_passes',
          }
        : {})}
      {...disableProps}
    />
  );
};
